import { useQuery } from '@tanstack/react-query';
import { ctcAdjustmentApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Audit history of cost-code adjustments for a CTC job. */
export function useCtcAdjustmentHistory(
  jobNumber: string | null | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.ctc.adjustmentHistory(jobNumber ?? ''),
    queryFn: ({ signal }) =>
      ctcAdjustmentApiClient.getAdjustmentHistory(
        jobNumber!,
        toCancelToken(signal),
      ),
    enabled: enabled && !!jobNumber,
    staleTime: 0,
    meta: { errorContext: 'CTC adjustment history' },
  });
}
